export default __webpack_public_path__ + "static/media/login_landing.5c2af169.jpeg";